module.exports = __webpack_public_path__ + "static/media/sending.0727f516.svg";